/* eslint-disable */
import React, { useEffect, useState } from "react";
import './SideMenu.scss'

import MenuOption from "../../molecules/MenuOption/MenuOption";
import logo from '../../../assets/img/logo.png'
import logoIcono from '../../../assets/img/iconoLogo.png'
import menuHamburguesa from '../../../assets/icons/menuHamburguesa.svg'
import IDLogo from '../../../assets/img/LOGO_ID_BLANCO_NARANJA.png'
import Header from "../Header/Header";
import { filterMenuByPermissions } from "./formatMenu";
import { useMenu } from "../../../context/MenuContext";

const SideMenu = ({ children, setAuth }) => {
    // State definitions
    const [sizing, setSizing] = useState({
        width: window.innerWidth
    });
    const [mostrarMenu, setMostrarMenu] = useState();
    const [ocultarMenuMovil, setOcultarMenuMovil] = useState(true);
    const [cambioDeMenu, setCambioDeMenu] = useState(false);
    const [menuPermisos, setMenuPermisos] = useState([]);
    const { menuData } = useMenu();

 

    // Window resize handler
    const Resizing = () => {
        setSizing({
            width: window.innerWidth
        });
    };

    // Setup resize listener
    useEffect(() => {
        window.addEventListener('resize', Resizing);
        return () => {
            window.removeEventListener('resize', Resizing);
        };
    }, []);

    // Handle menu change state
    useEffect(() => {
        const menuContainer = document.getElementById("sideMenu");
        if (cambioDeMenu) {
            menuContainer.classList.remove("sideMenu");
            menuContainer.classList.add("menuChicoAbierto");
            menuContainer.classList.remove("menuChico");
        } else {
            menuContainer.classList.remove("sideMenu");
            menuContainer.classList.add("menuChico");
            menuContainer.classList.remove("menuChicoAbierto");
        }
    }, [cambioDeMenu]);

    // Handle responsive behavior
    useEffect(() => {
        if (sizing.width > 1023) {
            setMostrarMenu(true);
            setOcultarMenuMovil(true);
        }
    }, [sizing]);

    // Handle show/hide menu
    useEffect(() => {
        const menuContainer = document.getElementById("sideMenu");
        if (mostrarMenu) {
            menuContainer.classList.add("sideMenu");
            menuContainer.classList.remove("menuChico");
        } else {
            menuContainer.classList.remove("sideMenu");
            menuContainer.classList.add("menuChico");
        }
    }, [mostrarMenu]);

    // Initialize mobile view
    useEffect(() => {
        const menuContainer = document.getElementById("sideMenu");
        if (sizing.width < 1023) {
            setMostrarMenu(true);
            menuContainer.classList.add("sideMenu");
            menuContainer.classList.remove("menuChico");
        }
    }, []);
    // Load menu data
    useEffect(() => {
        if (menuData.length > 0) {
            setMenuPermisos(filterMenuByPermissions(menuData));
        }
    }, [menuData]);

    // Render menu logo based on state
    const renderMenuLogo = () => {
        if (mostrarMenu || cambioDeMenu) {
            return <img src={logo} className="logo" alt="Company Logo" />;
        } else {
            return (
                <div className="containerLog">
                    <img src={logoIcono} className="logoIcono" alt="Company Icon" />
                </div>
            );
        }
    };

    // Render menu items
    const renderMenuItems = () => {
        return menuPermisos.map((item, key) => (
            <React.Fragment key={key}>
                <div
                    id="cambuioDeMenu"
                    className={`${mostrarMenu || cambioDeMenu ? "" : "menuComprimido"}`}
                >
                    {mostrarMenu || cambioDeMenu ? (
                        <MenuOption menuData={menuPermisos[key]} index={key} />
                    ) : (
                        <img
                            onMouseMove={() => setCambioDeMenu(true)}
                            width="20px"
                            src={require(`../../../assets/icons/sideMenu/${item.icon}`)}
                            alt={`Menu icon ${key}`}
                        />
                    )}
                </div>
            </React.Fragment>
        ));
    };

    return (
        <div id="sideMenu">
            {ocultarMenuMovil && (
                <div id="menu" className="menu">
                    <div id="contenedorMenu" className="contenedorMenu">
                        {sizing.width < 1024 && (
                            <img
                                className="botonRegresar"
                                src={menuHamburguesa}
                                alt="Menu button"
                                onClick={() => setOcultarMenuMovil(false)}
                            />
                        )}

                        {/* Company logo */}
                        <div className="logoCompany">
                            {renderMenuLogo()}
                        </div>

                        {/* Menu items */}
                        <div className="menuItemsContainer">
                            {renderMenuItems()}
                        </div>
                    </div>

                    {/* Footer fixed inside the menu */}
                    <div className="menuFooter">
                        <img className="idLogo" alt="idLogo" src={IDLogo} />
                        <div className="idText">
                            {mostrarMenu || cambioDeMenu ? "Innovación y Desarrollo" : ""}
                        </div>
                    </div>
                </div>
            )}

            <div className="fixedHeader" id="header">
                <Header
                    setCambioDeMenu={setCambioDeMenu}
                    ocultarMenuMovil={ocultarMenuMovil}
                    setOcultarMenuMovil={setOcultarMenuMovil}
                    setAuth={setAuth}
                    mostrarMenu={mostrarMenu}
                    setMostrarMenu={setMostrarMenu}
                    sizing={sizing}
                />
            </div>

            <div
                className="content"
                id="contenido"
                onClick={() => !mostrarMenu}
                onMouseMove={() => setCambioDeMenu(false)}
            >
                {children}
            </div>
        </div>
    );
};

export default SideMenu;